module.exports = __webpack_public_path__ + "static/media/permissrion-location-v2.85ee2718.png";